import { Component } from '@angular/core';


export class SkyCheckboxDemoComponent {
  public checkboxItems = [
    {
      description: 'Checkbox 1'
    },
    {
      description: 'Checkbox 2',
      checked: true
    },
    {
      description: 'Disabled',
      disabled: true
    },
    {
      description: 'Disabled and selected',
      checked: true,
      disabled: true
    }
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-checkbox-demo',
  template: `<fieldset>
  <legend>Checkbox options</legend>
  <ul class="sky-list-unstyled">
    <li *ngFor="let checkboxItem of checkboxItems">
      <sky-checkbox [(ngModel)]="checkboxItem.checked" [disabled]="checkboxItem.disabled">
        <sky-checkbox-label>
          {{ checkboxItem.description }}
        </sky-checkbox-label>
      </sky-checkbox>
    </li>
  </ul>
</fieldset>
<b>Checked state:</b>
<ul class="sky-list-unstyled">
  <li *ngFor="let checkboxItem of checkboxItems">
    {{ checkboxItem.description }}: <b>{{ checkboxItem.checked ? 'true': 'false' }}</b>
  </li>
</ul>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
